import React from 'react';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import {useVideoBannerContext} from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import {useVideoProgressBar} from './useVideoProgressBar';

export const VideoProgressbar = () => {
    const {
        playedProgress,
        setPlayedProgress,
        setIsDragging,
        isDragging,
        bufferedProgress,
        videoRef
    } = useVideoBannerContext();

    const {progressBarRef, handleDragStart} = useVideoProgressBar({
        videoRef,
        setPlayedProgress,
        setIsDragging,
        isDragging,
        bufferedProgress
    });
    return (
        <div
            ref={progressBarRef}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
            className={styles.videoProgressContainer}
        >
            <div className={styles.videoProgress}></div>
            <div
                className={styles.videoProgressBuffered}
                style={{width: `${bufferedProgress}%`}}
            ></div>
            <div
                className={styles.videoProgressPlayed}
                style={{width: `${playedProgress}%`}}
            ></div>
        </div>
    );
};
